import React, { memo } from 'react';

import { Logo } from '@assets/icons';

import { useWindowDimensions } from '@hooks';

import { EScreenTypes } from '@enum';

import { NavLinks } from './NavLinks';
import { ThemeToggle } from './ThemeToggle';
import { NavLinksMobile } from './NavLinksMobile';

import { TopNavBarProps } from './TopNavBar.types';

import {
  LogoContainer,
  ToggleButtonContainer,
  TopNavBarContainer,
} from './TopNavBar.styled';

export const TopNavBar = memo(
  ({ scrollToSection, themeSwitcher }: TopNavBarProps) => {
    const { type } = useWindowDimensions();

    return (
      <TopNavBarContainer>
        <LogoContainer>
          <Logo type={type} />
        </LogoContainer>
        {type === EScreenTypes.mobile ? (
          <NavLinksMobile scrollToSection={scrollToSection} />
        ) : (
          <NavLinks scrollToSection={scrollToSection} />
        )}

        <ToggleButtonContainer>
          <ThemeToggle onChange={themeSwitcher} />
        </ToggleButtonContainer>
      </TopNavBarContainer>
    );
  },
);
